export default __webpack_public_path__ + "static/media/5.81a6dfc7.png";